import React from 'react';

const CricketSvg = (props) => (
  <svg
    viewBox="0 0 59.35 59.35"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="currentColor"
  >
    <g>
      <g>
        <path d="M48.764,0.058c-2.251,2.13-12.669,11.895-12.669,11.895l1.021,1.061l-0.951,0.917
          c-1.031-0.634-2.398-0.703-3.527,0.37c-1.826,1.734-4.595,3.513-7.282,4.44c-0.173-0.203-0.345-0.409-0.518-0.612
          c3.043-1.583,8.537-4.855,8.667-4.934l0.011-0.005l-0.103-0.037l-0.289-0.108c-0.115-0.034-0.231-0.067-0.354-0.084
          c-0.416-0.055-0.874-0.008-1.367,0.17c-2.701,0.976-5.667,2.253-8.603,2.989c-3.622-2.055-8.258,3.412-5.012,7.308
          c3.026,3.631,6.169,6.927,8.513,11.001c-1.349,2.25-4.492,3.467-6.457,5.068c-3.831,3.121-4.378,8.281-5.932,12.629
          c-1.283,3.586,4.41,5.113,5.681,1.564c1.532-4.287,1.858-8.438,5.968-11.107c0.46-0.299,0.918-0.6,1.368-0.903
          c-0.597,2.252-1.079,4.519-0.74,6.96c0.412,2.966,1.276,5.878,2.278,8.693c1.261,3.554,6.955,2.022,5.68-1.565
          c-0.851-2.388-1.556-4.831-2.06-7.313c-0.82-4.032,1.353-8.114,1.998-12.174c1.086-1.263,1.547-3.072,0.59-4.963
          c-1.469-2.901-3.351-5.458-5.366-7.92c2.793-1.229,5.411-2.954,7.493-4.932c0.968-0.918,1.08-2.026,0.705-2.965l1.039-1.001
          l1.021,1.061l12.67-11.894C52.237,3.667,52.863-0.536,48.764,0.058z"/>
        <path d="M18.411,15.114c0.288-0.333,0.514-0.698,0.686-1.079l0.415-0.056
          c0.028-0.003,0.056-0.011,0.082-0.025c0.288-0.146,0.517-0.327,0.697-0.536c1.352-1.568-0.067-4.621-0.137-4.768
          c-0.059-0.125-0.209-0.179-0.336-0.121l-1.501,0.699c-0.114-0.124-0.235-0.244-0.366-0.357c-0.201-0.173-0.414-0.321-0.634-0.452
          l1.409-1.633l-0.622-0.538l-1.558,1.809c-1.672-0.596-3.608-0.15-4.837,1.274c-1.599,1.853-1.392,4.648,0.459,6.243
          C14.019,17.171,16.814,16.964,18.411,15.114z M19.401,13.482l-0.106,0.015c0.168-0.562,0.22-1.146,0.162-1.721l0.898-0.25
          C20.368,12.321,20.148,13.083,19.401,13.482z M19.793,9.1c0.15,0.366,0.424,1.121,0.524,1.918c-0.02,0.001-0.04,0.003-0.061,0.009
          l-0.88,0.245c-0.128-0.582-0.373-1.14-0.733-1.638L19.793,9.1z"/>
        <path d="M8.098,33.294c-0.564,0-1.019,0.455-1.019,1.02v20.198c0,0.563,0.455,1.021,1.019,1.021
          s1.021-0.457,1.021-1.021V34.314C9.119,33.749,8.662,33.294,8.098,33.294z"/>
        <path d="M12.14,33.294c-0.563,0-1.019,0.455-1.019,1.02v20.198c0,0.563,0.457,1.021,1.019,1.021
          c0.213,0,0.411-0.065,0.573-0.178c-0.449-0.943-0.49-2.033-0.096-3.136c0.195-0.542,0.371-1.099,0.543-1.668V34.314
          C13.161,33.749,12.705,33.294,12.14,33.294z"/>
        <path d="M15.15,34.314v10.049c0.526-1.26,1.177-2.463,2.04-3.561v-6.488c0-0.562-0.455-1.02-1.019-1.02
          C15.605,33.294,15.15,33.749,15.15,34.314z"/>
        <path d="M8.644,33.294h2.611c0.301,0,0.545-0.244,0.545-0.547c0-0.299-0.244-0.543-0.545-0.543H8.644
          c-0.302,0-0.546,0.244-0.546,0.543C8.098,33.05,8.341,33.294,8.644,33.294z"/>
        <path d="M15.625,32.204h-2.612c-0.301,0-0.545,0.244-0.545,0.543c0,0.303,0.244,0.547,0.545,0.547h2.612
          c0.301,0,0.546-0.244,0.546-0.547C16.171,32.451,15.926,32.204,15.625,32.204z"/>
        <path d="M49.427,15.243c-0.004,0.268-0.051,0.592-0.08,0.965c-0.057,0.369-0.113,0.788-0.223,1.235
          c-0.099,0.449-0.246,0.924-0.414,1.42c-0.101,0.243-0.201,0.493-0.307,0.748c-0.121,0.248-0.244,0.5-0.371,0.757
          c-0.277,0.5-0.585,1.004-0.943,1.486c-0.355,0.482-0.746,0.952-1.172,1.388c-1.688,1.769-3.815,3.033-5.463,3.798
          c-0.826,0.386-1.539,0.653-2.039,0.827c-0.504,0.171-0.787,0.245-0.787,0.245l0.16,0.567c0,0,0.31-0.091,0.818-0.282
          c0.512-0.194,1.23-0.489,2.062-0.909c1.662-0.833,3.797-2.189,5.463-4.045c0.42-0.457,0.804-0.947,1.152-1.45
          c0.35-0.5,0.646-1.024,0.912-1.54c0.121-0.265,0.238-0.525,0.354-0.779c0.099-0.261,0.193-0.517,0.285-0.766
          c0.158-0.509,0.293-0.991,0.377-1.448c0.097-0.452,0.142-0.875,0.186-1.247c0.021-0.375,0.057-0.701,0.055-0.97
          c-0.005-0.539-0.006-0.846-0.006-0.846S49.442,14.705,49.427,15.243z"/>
      </g>
    </g>
  </svg>
);

export default CricketSvg;
